import React, { useEffect } from 'react';
import PageCarousel from '../components/PageCarousel';

function AuthorGuidelines() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const importantDates = [
    { event: "Submissions Starts", date: "March 2, 2026" },
    { event: "Submission Deadline", oldDate: "March 31, 2026", newDate: "April 07, 2026", newDate1: "April 15, 2026", newDate2: "April 30, 2026" },
    { event: "Review Results", date: "June 20, 2026" },
    { event: "Final Camera Ready Paper Submission", date: "June 20 – July 05, 2026" },
    { event: "Registration", date: "June 20 – July 05, 2026" }
  ];
  
  return (
    <div className="page-container">
      <PageCarousel />
      
      <section className="section-padding bg-light">
        <div className="container">
          {/* Header Section - Same as CFP */}
          <div className="row mb-5">
            <div className="col-12 text-center">
              <h1 className="display-4 fw-bold" style={{ color: '#111' }}>Author Guidelines</h1>
              <div className="title-separator mx-auto" style={{ background: '#70b60a', width: '80px', height: '4px', marginTop: '15px' }}></div>
              <p className="col-lg-12 mx-auto mt-4 lead text-muted" style={{ textAlign: 'justify' }}>
                Prospective authors are invited to submit full-length original research papers. In submitting a manuscript to <strong>NCVPRIPG 2026</strong>, authors acknowledge that no paper substantially similar in content has been or will be submitted elsewhere.
              </p>
            </div>
          </div>

          {/* Instructions Card */}
          <div className="row mb-5">
            <div className="col-lg-12">
              <div className="card shadow-sm border-0 p-4">
                <div className="d-flex align-items-center mb-4">
                 
                  <h3 className="fw-bold mb-4 border-start border-4 border-success ps-3">Instructions for Preparing Manuscripts</h3>
                </div>
                
                <div className="row g-4">
                  <div className="col-md-12">
                    <p className="text-muted">Authors should prepare their manuscripts of <strong>10-15 pages</strong> (including all text, figures, and references). The manuscript must be submitted in <strong>PDF format only</strong>.</p>
                  </div>
                  <div className="col-md-6">
                    <div className="topic-item p-3 border rounded mb-2 d-flex align-items-center">
                      <i className="fas fa-check-circle text-success me-2"></i>
                      <span>File size must not exceed 10 MB.</span>
                    </div>
                    <div className="topic-item p-3 border rounded mb-2 d-flex align-items-center">
                      <i className="fas fa-check-circle text-success me-2"></i>
                      <span>Use scalable fonts with all fonts embedded.</span>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="topic-item p-3 border rounded mb-2 d-flex align-items-center">
                      <i className="fas fa-check-circle text-success me-2"></i>
                      <span>No transparent pixels/alpha-channels in images.</span>
                    </div>
                    <div className="topic-item p-3 border rounded mb-2 d-flex align-items-center">
                      <i className="fas fa-check-circle text-success me-2"></i>
                      <span>Disable Adobe Document Protection/Security.</span>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="alert alert-warning border-0 small">
                      <i className="fas fa-info-circle me-2"></i>
                      If the final manuscript in conference format exceeds 15 pages, additional charges will apply for each extra page.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Templates Section - Same Button Style as CFP */}
          <div className="row g-4 mb-5">
            <div className="col-lg-7">
              <div className="card shadow-sm border-0 h-100 p-4">
                <h3 className="fw-bold mb-4 border-start border-4 border-success ps-3">Preparing Your Paper</h3>
                <p className="text-muted mb-4">Download the structured guidelines and official templates for your proceedings paper:</p>
                
                <div className="row g-3">
                  <div className="col-sm-6">
                    <a href="https://www.springer.com/gp/computer-science/lncs/conference-proceedings-guidelines" className="btn btn-outline-success w-100 py-3 d-flex align-items-center justify-content-center">
                      <i className="fas fa-file-pdf me-2"></i> Guidelines PDF
                    </a>
                  </div>
                  <div className="col-sm-6">
                    <a href="https://www.overleaf.com/latex/templates/springer-lecture-notes-in-computer-science/kzwwpvhwnvfj#.WuA4JS5uZpi" target="_blank" rel="noopener noreferrer" className="btn btn-outline-success w-100 py-3 d-flex align-items-center justify-content-center">
                      <i className="fas fa-leaf me-2"></i> Overleaf Template
                    </a>
                  </div>
                  <div className="col-sm-6">
                    <a href="https://ncvpripg25.github.io/ncvpripg25/files/Latexcvip.zip" target="_blank" rel="noopener noreferrer" className="btn btn-outline-dark w-100 py-3 d-flex align-items-center justify-content-center">
                      <i className="fas fa-code me-2"></i> LaTeX Template
                    </a>
                  </div>
                  <div className="col-sm-6">
                    <a href="https://ncvpripg25.github.io/ncvpripg25/files/Microsoftcvip.zip" target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary w-100 py-3 d-flex align-items-center justify-content-center">
                      <i className="fas fa-file-word me-2"></i> Word Template
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-5">
              <div className="card shadow-sm border-0 h-100 p-4 ">
                <h3 className="fw-bold mb-4 border-start border-4 border-success ps-3">Manuscript Submission</h3>
                <p className="opacity-75">Upload your manuscript online at the NCVPRIPG 2026 Microsoft Research portal via the link below:</p>
                <div className="mt-auto py-3">
                   <a href="https://cmt3.research.microsoft.com/NCVPRIPG2026/" target="_blank" rel="noopener noreferrer" className="btn btn-light btn-lg w-100 fw-bold text-center">
                     CMT Submission Link <i className="fas fa-external-link-alt ms-2"></i>
                   </a>
                </div>
                <small className="mt-3 d-block text-center">
                  CMT Acknowledgement: The Microsoft CMT service was used for managing the peer-reviewing process for this conference. This service was provided for free by Microsoft and they bore all expenses, including costs for Azure cloud services as well as for software development and support.
                </small>
              </div>
            </div>
          </div>

          {/* Dates & Contact - Same Table Style as CFP */}
          <div className="row g-4">
            <div className="col-lg-8">
              <div className="card shadow-sm border-0 overflow-hidden">
                <div className="card-header p-3">
                  <h4 className="fw-bold border-start border-4 border-success ps-3"><i className="fas fa-calendar-alt me-2 text-success"></i> Important Dates</h4>
                </div>
                <div className="table-responsive">
                  <table className="table table-hover mb-0">
                  <thead style={{ background: '#70b60a', color: '#fff' }}>
                    <tr>
                      <th>Event</th>
                      <th>Date</th>
                    </tr>
                  </thead>

                  <tbody>
                    {importantDates.map((item, idx) => (
                      <tr key={idx}>
                        <td>{item.event}</td>
                        <td>
                          {item.oldDate ? (
                            <>
                              {/* Old Date */}
                              <span style={{
                                textDecoration: 'line-through',
                                marginRight: '8px',
                                color: '#777'
                              }}>
                                {item.oldDate}
                              </span>

                              {/* If newDate1 exists → strike newDate also */}
                              {item.newDate2 ? (
                                <>
                                  <span style={{
                                    textDecoration: 'line-through',
                                    marginRight: '8px',
                                    color: '#999'
                                  }}>
                                    {item.newDate}
                                  </span>

                                  <span style={{
                                    textDecoration: 'line-through',
                                    marginRight: '8px',
                                    color: '#999'
                                  }}>
                                    {item.newDate1}
                                  </span>

                                  <strong style={{ color: 'red' }}>
                                    {item.newDate2}
                                  </strong>
                                </>
                              ) : (
                                <strong style={{ color: 'red' }}>
                                  {item.newDate2}
                                </strong>
                              )}
                            </>
                          ) : (
                            item.date
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>

                </table>
                </div>
              </div>
            </div>
            
            <div className="col-lg-4 text-center">
              <div className="card shadow-sm border-0 h-100 p-4 border-top border-5 border-success d-flex flex-column justify-content-center">
                <div className="mb-3">
                  <i className="fas fa-envelope-open-text fa-3x text-success"></i>
                </div>
                <h4 className="fw-bold">Any Queries?</h4>
                <p className="text-muted mb-4">Please contact us at:</p>
                <a href="mailto:ncvpripg2026@lnmiit.ac.in" className="h5 text-success text-decoration-none fw-bold">
                  ncvpripg2026@lnmiit.ac.in
                </a>
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

export default AuthorGuidelines;